import { AutomationsPermissions } from './automations.permissions';
import { AutomationsRoles } from './automations.roles';

export const automationsMappings = {
  [AutomationsPermissions.GET_LISTED_AUTOMATIONS]: [AutomationsRoles.VIEWER],
  [AutomationsPermissions.GET_AUTOMATION]: [AutomationsRoles.VIEWER],
  [AutomationsPermissions.ADD_AUTOMATION]: [AutomationsRoles.CREATOR],
  [AutomationsPermissions.EDIT_AUTOMATION]: [AutomationsRoles.EDITOR],
  [AutomationsPermissions.DELETE_AUTOMATION]: [AutomationsRoles.EDITOR],
};
